import { CButton, CCol, CForm, CFormInput, CFormLabel, CModal, CModalBody, CModalHeader, CModalTitle, CNav, CNavItem, CNavLink, CRow, CTabContent, CTabPane, CModalFooter } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import { Reorder } from 'framer-motion'
import CloudinaryUploader from './CloudinaryUploader'
import MediaCopy from './MediaCopy'
import { Plus, X } from 'lucide-react'
import OneDriveUploader from './OneDriveUploader'

const Media = ({ showMediaModel, setShowMediaModel, editEducations, parentId, file, setFile, handleFileSave, setParentAccordions, type, differentModuleCopyFunctionality, fileStatmentData, attachedType, showTab = true, ApiCallingType, handelSubmit }) => {
  const [activeTab, setActiveTab] = useState(0)
  const onClose = () => {
    // fetchEducationsFromLs();
    setFile([])
    setShowMediaModel(false)
  }

  const handleDeleteFile = (id, item) => {
    setFile((prevFiles) => {
      return prevFiles.filter((file) => file.id !== id)
    })
    handleFileSave(item?.url)
    // setFile(prevFiles => {
    //     if (prevFiles.length === 1) return [];
    //     return prevFiles.filter((_, i) => i !== index);
    // });
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)

      if (isDuplicate) return prevFiles

      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
  }
  const handleDragStart = (e, currentIndex) => {
    e.dataTransfer.setData('text/plain', currentIndex.toString())
    e.dataTransfer.effectAllowed = 'move'
  }

  const handleDrop = (e, targetIndex) => {
    e.preventDefault()
    const currentIndex = parseInt(e.dataTransfer.getData('text/plain'), 10)

    if (currentIndex !== targetIndex) {
      const newFiles = [...file]
      const [movedItem] = newFiles.splice(currentIndex, 1)
      newFiles.splice(targetIndex, 0, movedItem)
      setFile(newFiles)
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'
  }

  return (
    <CModal scrollable visible={showMediaModel} size="lg" className="patient-theme-modal">
      <CModalBody>
        <CForm>
          <CRow className="d-flex justify-content-center">
            {showTab && (
              <div className="pe-tab-underline-nav mb-3">
                <CNav role="tablist" className="justify-content-center">
                  <CNavItem>
                    <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                      Add
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink
                      active={activeTab === 1}
                      onClick={() => {
                        setActiveTab(1)
                        handelSubmit(false)
                      }}
                    >
                      Copy
                    </CNavLink>
                  </CNavItem>
                </CNav>
              </div>
            )}

            <div>
              {
                <div activeTab={activeTab} onActiveTabChange={setActiveTab}>
                  <CTabContent className="mt-1">
                    {activeTab === 0 && (
                      <CTabPane visible={activeTab === 0}>
                        <CCol xs={12} className="mt-3">
                          <CFormLabel>Upload File</CFormLabel>
                          <div className="d-flex  align-item-center gap-2">
                            {/* <div>
                                                    {file.length > 0 && (
                                                        <CCol xs={12} className=" ">
                                                            <div className="d-flex  flex-wrap align-items-center gap-2">
                                                                {file.map((fileItem, i) => {
                                                                    const isImage = fileItem.type === 'image';
                                                                    const isVideo = fileItem.type === 'video';
                                                                    const isDocument = fileItem.type === 'document';

                                                                    return (
                                                                        <>
                                                                            <div className='d-flex flex-column gap-2 align-items-center'>
                                                                                <div
                                                                                    key={i}
                                                                                    draggable
                                                                                    onDragStart={(e) => handleDragStart(e, i)}
                                                                                    onDrop={(e) => handleDrop(e, i)}
                                                                                    onDragOver={handleDragOver}
                                                                                    className="shadow rounded p-2 position-relative"
                                                                                    style={{
                                                                                        width: "100px",
                                                                                        height: "100px",
                                                                                        overflow: "hidden",
                                                                                        borderRadius: "8px",
                                                                                        cursor: "grab",
                                                                                        flexShrink: 0,

                                                                                        background: "#f8f9fa",
                                                                                        position: "relative",
                                                                                    }}
                                                                                >

                                                                                    <CButton
                                                                                        className="position-absolute top-0 end-0   border-0   rounded-circle"
                                                                                        style={{
                                                                                            width: "20px",
                                                                                            height: "20px",
                                                                                            fontSize: "10px",
                                                                                            background: "var(--ui-color-primary, #2b7cd3)",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            cursor: "pointer",
                                                                                            color: 'white'
                                                                                        }}
                                                                                        onClick={() => handleDeleteFile(fileItem.url, i)}
                                                                                    >
                                                                                        x
                                                                                    </CButton>

                                                                                    {isImage ? (

                                                                                        <>
                                                                                            <img
                                                                                                src={fileItem.url}
                                                                                                alt="Uploaded"
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "100%",
                                                                                                    objectFit: "cover",
                                                                                                    borderRadius: "8px",
                                                                                                }}
                                                                                            />

                                                                                        </>

                                                                                    ) : isVideo ? (
                                                                                        <video
                                                                                            controls
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                height: "100%",
                                                                                                objectFit: "cover",
                                                                                            }}
                                                                                        >
                                                                                            <source src={fileItem.url} type="video/mp4" />
                                                                                        </video>
                                                                                    ) : isDocument ? (
                                                                                        <div className="d-flex flex-column align-items-center justify-content-center h-100">
                                                                                            <iframe
                                                                                                src={fileItem.url}
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "100%",
                                                                                                    border: "none",
                                                                                                    borderRadius: "8px",
                                                                                                }}
                                                                                                title="Document Viewer"
                                                                                            />




                                                                                        </div>
                                                                                    ) : (
                                                                                        <a href={fileItem.url} target="_blank" rel="noopener noreferrer" className="text-center">
                                                                                            {fileItem.fileName || "File"}
                                                                                        </a>
                                                                                    )}

                                                                                </div>
                                                                                <div style={{ width: '100px', height: '20px', overflow: 'auto', textDecoration: 'none', marginTop: '5px', borderRadius: '10px' }}>
                                                                                    <a
                                                                                        href={fileItem.url}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="  text-dark"
                                                                                        style={{
                                                                                            display: 'inline-block',
                                                                                            padding: '2px 5px',
                                                                                            backgroundColor: '#f0f0f0',
                                                                                            borderRadius: '4px',
                                                                                            fontSize: '0.75rem',
                                                                                            fontWeight: 'bold',
                                                                                            color: '#333',
                                                                                            textDecoration: 'none',
                                                                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                                            transition: 'background-color 0.3s ease',
                                                                                        }}
                                                                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                                                                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                                                                    >
                                                                                        {fileItem.fileName || "File"}
                                                                                    </a>
                                                                                </div>
                                                                            </div>

                                                                        </>

                                                                    );
                                                                })}
                                                            </div>
                                                        </CCol>
                                                    )}

                                                </div> */}
                            <CloudinaryUploader filesAl={file} onDelete={handleDeleteFile} onUploadSuccess={handleCloudinaryUpload} />
                          </div>
                        </CCol>
                      </CTabPane>
                    )}

                    {activeTab === 1 && (
                      <CTabPane visible={activeTab === 1}>
                        <MediaCopy
                          setParentAccordions={setParentAccordions}
                          parentId={parentId}
                          type={type}
                          differentModuleCopyFunctionality={differentModuleCopyFunctionality}
                          setShowMediaModel={setShowMediaModel}
                          fileStatmentData={fileStatmentData}
                          attachedType={attachedType}
                          ApiCallingType={ApiCallingType}
                        />
                      </CTabPane>
                    )}
                  </CTabContent>
                </div>
              }
            </div>
            {/* <CCol xs={12} className='d-flex flex-column justify-content-between gap-2'>
                            <CCol>
                                <CFormLabel>Select Diagnosis</CFormLabel>
                                <CreatableSelect
                                    isClearable
                                    value={selectedCategory}
                                    onChange={setSelectedCategory}
                                    options={diagnosis}
                                />
                            </CCol>
                            <CCol>
                                <CFormLabel className='mt-4'>Title</CFormLabel>
                                <CFormInput
                                    type="text"
                                    placeholder="Enter title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </CCol>
                        </CCol> */}

            {/* Cloudinary Upload Component */}
          </CRow>
        </CForm>
      </CModalBody>
      {activeTab === 0 && (
        <CModalFooter>
          <CButton color="secondary" onClick={onClose} className="ui-action-btn ui-action-btn--secondary">
            Close
          </CButton>
          {showTab && (
            <CButton
              onClick={() => {
                handleFileSave()
                onClose()
              }}
              className="px-4 ui-action-btn ui-action-btn--primary"
            >
              {editEducations ? 'Update' : 'Save'}
            </CButton>
          )}
        </CModalFooter>
      )}
    </CModal>
  )
}

export default Media
